import {
  EVENT_ACTION_CLICKED,
  EVENT_BUTTON_INTERACTION,
  EVENT_PROPERTY_ACTION,
  EVENT_PROPERTY_DESCRIPTOR,
  EVENT_PROPERTY_UI_CONTEXT,
} from '../../utils/analytics/events'
import { useAnalytics } from '../components/Analytics'
import { ButtonProps } from '../components/Button/Button'

export const useButtonProps = (props: ButtonProps) => {
  const { analytics } = useAnalytics()
  const { tracking, onClick, ...restButtonProps } = props

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    analytics?.track(EVENT_BUTTON_INTERACTION, {
      [EVENT_PROPERTY_ACTION]: EVENT_ACTION_CLICKED,
      [EVENT_PROPERTY_DESCRIPTOR]: tracking?.descriptor,
      [EVENT_PROPERTY_UI_CONTEXT]: tracking?.ui_context,
    })

    if (onClick) {
      onClick(e)
    }
  }

  return {
    onClick: handleClick,
    ...restButtonProps,
  }
}
